module.exports = __webpack_public_path__ + "images/dokument.c689efdc8df908e0e613b7f46eb8fa2b.png";